//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbProductTileAttributes from '@/elements/product-tile/product-tile-content/product-tile-attributes/product-tile-attributes.vue'
import wcs from '@/scripts/libs/wcs'
import { OPTICAL } from '@/scripts/constants/pdp'
import { BRL, GIFTCARDS } from '@/scripts/constants/store'
import { BRASIL_INSTALLMENTS } from '@/scripts/constants/plp.ts'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'
export default {
  name: 'product-tile-content',
  components: {
    RbProductTileAttributes,
  },
  inject: ['isLoading'],
  props: {
    selectedVariant: {
      type: Object,
      default: () => ({}),
    },
    currentPromotion: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      BRASIL_INSTALLMENTS,
    }
  },
  computed: {
    isProductGiftCard() {
      return GIFTCARDS.includes(this.selectedVariant?.product_type)
    },
    productIsOptical() {
      return this.selectedVariant?.product_type === OPTICAL
    },
    isOpticsNotSellableInCountry() {
      const { pdp } = wcs.getStoreConfig()
      return this.productIsOptical && !pdp?.isOpticsSellable
    },
    areInstallmentsVisible() {
      return (
        this.selectedVariant.status && !this.isProductGiftCard && !this.selectedVariant?.isPreOrder
      )
    },
    isBrazil() {
      return wcs.isBrazil()
    },
    splitPrice() {
      const priceToBeDiscounted =
        this.currentPromotion.discountedPrice || this.selectedVariant.price
      const discountedPriceNum = priceToBeDiscounted?.replace(/\D/g, '')
      const priceLabel = (discountedPriceNum && (discountedPriceNum / 1000).toFixed(2)) || undefined
      return new Intl.NumberFormat(WcsLocales.PT_BR, { style: 'currency', currency: BRL }).format(
        priceLabel
      )
    },
  },
}
